import api from "./axios";

// ========================
// Teacher APIs
// ========================

export const getMyAssignments = () =>
  api.get("teacher/my-assignments/");

export const getAssignmentStudents = (assignmentId) =>
  api.get(`teacher/assignment-students/${assignmentId}/`);


// ========================
// Results APIs
// ========================

export const enterMark = (data) =>
  api.post("results/enter-marks/", data);




// ========================
// Reports
// ========================

export const generateReport = (studentId, termId) =>
  `${api.defaults.baseURL}reports/generate-report/${studentId}/${termId}/`;


export const getAssessmentTypes = () =>
  api.get("results/assessment-types/");

export const getActiveTerms = () =>
  api.get("results/active-terms/");

export const getTeacherAnalytics = () =>
  api.get("results/teacher-dashboard-analytics/");


// ========================
// Academics
// ========================

export const getClasses = () =>
  api.get("academics/classes/");


// ========================
// Students
// ========================

export const getStudentsByClass = (classId) =>
  api.get(`students/by-class/${classId}/`);


// ========================
// NEW: Fee Clearance APIs
// ========================

// get students with fee status
export const getStudentsFeesByClass = (classId) =>
  api.get(`students/fees-by-class/${classId}/`);

// update student fee clearance
export const updateStudentFeeStatus = (data) =>
  api.post("students/update-fee-status/", data);


// ========================
// Reports
// ========================

export const saveSubjectRemark = (data) =>
  api.post("reports/save-subject-remark/", data);


// ========================
// Marks Checking
// ========================

export const checkExistingMarks = (params) =>
  api.get("/results/check-existing/", { params });

// ========================
// COMMUNICATION CENTER
// ========================

// send single student report card
export const sendReportCard = (data) =>
  api.post(
    "reports/send-report-card/",
    data
  );

// send custom parent message
export const sendParentMessage = (data) =>
  api.post(
    "reports/send-parent-message/",
    data
  );

// ========================
// ATTENDANCE
// ========================

// load students for attendance
export const getAttendanceStudents = (
  assignmentId
) =>
  api.get(
    `attendance/students/${assignmentId}/`
  );

// save attendance
export const saveAttendance = (
  data
) =>
  api.post(
    "attendance/save/",
    data
  );